{
  "instances": {
    "jolokia": {
      "label": "JMX",
      "close": "Cerrar",
      "domains": "Dominios",
      "execute": "Ejecutar",
      "executing": "Ejecutando...",
      "execution_failed": "Ejecución fallida.",
      "execution_successful": "Ejecución exitosa.",
      "mbeans": "MBeans"
    }
  }
}
